export enum NotificationType {
    EMAIL="EMAIL",
    TEXT="TEXT"
}
